import { uniqBy } from "lodash";
import { GenericRow } from "../../../Components/Tables/_Tables/useColumnConstructor";
import { Milestone, MixtureComponent } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { FeedComponentInfo } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";

export interface FeedCurveTableData extends GenericRow {
  milestone?: string,
  id: number,
  dsWeight: number,
  totalAmount: number, 
}

// With or without ds
export const convertDenseToSparse = (mixture: MixtureComponent[], milestones: Milestone[], componentIds: number[], components: FeedComponentInfo[], isPercentileEdit: boolean): Map<number,FeedCurveTableData>  => {
  const sparseData: Map<number,FeedCurveTableData> = new Map();
  const filteredComponents: Map<number, FeedComponentInfo> = new Map();
  components.forEach((component) => {filteredComponents.set(component.id, component)});
  [...mixture].sort((mixA, mixB) => mixA.day-mixB.day).forEach((entry) => {
    const component = filteredComponents.get(entry.component);
    const ds = component?.ds ?? 0;
    if (sparseData.has(entry.day)){
      const previousValues = sparseData.get(entry.day)!;
      sparseData.set(entry.day, {...previousValues, [entry.component]: entry.amount, dsWeight: previousValues.dsWeight + (ds*entry.amount), totalAmount: previousValues.totalAmount + entry.amount})
    } else {
      sparseData.set(entry.day, {[entry.component]: entry.amount, id: entry.day, dsWeight: (ds*entry.amount), totalAmount: entry.amount})
    }
  })
  milestones.forEach(({startDay, milestone}) => {
    if (sparseData.has(startDay)) {
      const previousValues = sparseData.get(startDay)!
      sparseData.set(startDay, {...previousValues, milestone})
    }
  })
  sparseData.forEach((row, key) => {
    const componentValue = Object.assign({},...componentIds.map((id) => getValueForComponent(id, row, isPercentileEdit)));
    sparseData.set(key, {...row, ...componentValue, ds: row.totalAmount === 0 ? 0 : Math.round((row.dsWeight/row.totalAmount)*100)/100})
  })
  return sparseData;
}

const getValueForComponent = (id: number, data: FeedCurveTableData, isPercentileEdit: boolean) => {
  if (!isPercentileEdit) {
    return {[String(id)]: data[String(id)]};
  }
  const amount = data[String(id)] as number ?? 0
  if (amount===0) {return {[String(id)]: undefined}}
  return {[String(id)]: Math.round(((amount / data.totalAmount)*100)*100)/100};
}


export const convertSparseToDense = (sparseData: FeedCurveTableData[], accessors: number[], feedComponents: FeedComponentInfo[]) => {
  const mixture: {day: number, component:number, amount: number}[] = [];
  const milestones: Milestone[] = [];
  sparseData.forEach((row) => {
    Object.entries(row).forEach(([key, value]) => {
      if (key === "milestone" && value) {
        milestones.push({startDay: row.id, milestone: String(value)})
      }
      if (accessors.includes(+key) && (value !== undefined && value !== "")) {
        mixture.push({day: row.id, component: +key , amount: +value})
      }
    })
  })

  return {mixture, milestones: uniqBy(milestones.sort((milestoneA, milestoneB) => milestoneA.startDay-milestoneB.startDay),(milestone) => milestone.milestone)};
}